var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "note",
      staticClass: "contact-note",
      class: {
        "private-note": _vm.note.isPrivate,
      },
    },
    [
      _vm.note.createdUser
        ? _c(
            "div",
            { staticClass: "contact-note-agent-avatar" },
            [
              _c("AgentAvatar", {
                attrs: { userID: _vm.note.createdUser._id, size: 30 },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "contact-note-content" }, [
        _c("div", { staticClass: "contact-note-details" }, [
          _c("div", { staticClass: "contact-note-details-title" }, [
            _c("div", { staticClass: "contact-note-agent-name" }, [
              _c("div", { staticClass: "contact-note-agent-name" }, [
                _vm._v(_vm._s(_vm.note.createdUser.name)),
              ]),
              _vm._v(" "),
              _vm.note.isPrivate
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: { placement: "left-center" },
                          expression: "{ placement: 'left-center' }",
                        },
                      ],
                      staticClass: "material-icons",
                      attrs: { content: "This only showing you." },
                    },
                    [
                      _vm._v(
                        "\n                        vpn_lock\n                    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "contact-note-more-actions" },
              [
                _c(
                  "a-popover",
                  {
                    attrs: {
                      trigger: "click",
                      placement: "bottomRight",
                      overlayClassName: "contact-note-popover",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "more-actions" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "action-button",
                                  on: { click: _vm.markPrivateOrPublic },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "action-button-icon" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "material-icons" },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.note.isPrivate
                                                  ? "public"
                                                  : "vpn_lock"
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "action-button-text" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.note.isPrivate
                                              ? _vm.$t("message.showNote")
                                              : _vm.$t("message.hideNote")
                                          ) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "action-button",
                                  on: {
                                    click: function ($event) {
                                      _vm.updatingNote = true
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "action-button-icon" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "material-icons" },
                                        [_vm._v("settings")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "action-button-text" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.$t("message.updateNote")) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "action-button",
                                  on: {
                                    click: function ($event) {
                                      _vm.deleteMode = true
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "action-button-icon" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "material-icons" },
                                        [_vm._v("delete")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "action-button-text" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.$t("message.delete")) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.isPopoverVisible,
                      callback: function ($$v) {
                        _vm.isPopoverVisible = $$v
                      },
                      expression: "isPopoverVisible",
                    },
                  },
                  [
                    _vm._v(" "),
                    !_vm.updatingNote
                      ? _c("div", { staticClass: "material-icons" }, [
                          _vm._v("more_vert"),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _vm.updatingNote
                  ? _c(
                      "div",
                      {
                        staticClass: "material-icons",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            _vm.updatingNote = false
                          },
                        },
                      },
                      [_vm._v("close")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.updatingNote
            ? _c(
                "div",
                { staticClass: "contact-notes-form" },
                [
                  _c("a-textarea", {
                    staticClass: "non-resizable",
                    staticStyle: { width: "95%" },
                    attrs: { "auto-size": { minRows: 2, maxRows: 10 } },
                    model: {
                      value: _vm.description,
                      callback: function ($$v) {
                        _vm.description = $$v
                      },
                      expression: "description",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "contact-notes-form-actions" }, [
                    _c("div"),
                    _vm._v(" "),
                    _c("div", { staticClass: "contact-notes-update-buttons" }, [
                      _c(
                        "div",
                        {
                          staticClass: "note-button note-update-cancel",
                          on: {
                            click: function ($event) {
                              _vm.updatingNote = null
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("message.cancel")) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "note-button note-update-ok",
                          on: { click: _vm.makeUpdateNote },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("message.update")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ],
                1
              )
            : _c("div", { staticClass: "contact-note-details-description" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.note.description) +
                    "\n            "
                ),
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "contact-note-details-date" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.note.updatedAt
                    ? new Date(_vm.note.updatedAt).toLocaleDateString() +
                        " - " +
                        new Date(_vm.note.updatedAt).toLocaleTimeString(
                          "tr-TR",
                          { hour12: false }
                        )
                    : new Date(_vm.note.createdAt).toLocaleDateString() +
                        " - " +
                        new Date(_vm.note.createdAt).toLocaleTimeString(
                          "tr-TR",
                          { hour12: false }
                        )
                ) +
                "\n            "
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.deleteMode
          ? _c("div", { staticClass: "note-action-button" }, [
              _c(
                "div",
                {
                  staticClass: "note-delete-button note-button",
                  on: { click: _vm.deleteNote },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.delete")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "note-update-button note-button",
                  on: {
                    click: function ($event) {
                      _vm.deleteMode = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.cancel")) +
                      "\n            "
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }